import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Link } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { styles } from "./styles";
import { DOCUMENTATION_URL } from "../../constants";
import { getStarterPrompts } from "../../hooks/useStarterPrompts";
import { Prompt } from "../../types/frontend";

interface StarterPageProps {
  onPromptSend: (text: string) => void;
}

const StarterPage: React.FC<StarterPageProps> = ({ onPromptSend }) => {
  const [displayPrompts, setDisplayPrompts] = useState<Prompt[]>([]);
  const theme = useTheme();

  useEffect(() => {
    setDisplayPrompts(getStarterPrompts());
  }, []);

  return (
    <Box sx={styles.starterPromptsContainer}>
      <Box sx={styles.starterTitleContainer}>
        <Box
          component="img"
          src="/materiom_logo.png"
          alt="Materiom Logo"
          sx={styles.starterLogo}
        />
        <Typography
          variant="h5"
          sx={
            typeof styles.starterTitle === "function"
              ? styles.starterTitle(theme)
              : styles.starterTitle
          }
        >
          Materiom AI
        </Typography>
      </Box>
      <Typography
        variant="subtitle1"
        sx={
          typeof styles.starterSubtitle === "function"
            ? styles.starterSubtitle(theme)
            : styles.starterSubtitle
        }
      >
        Your Research Assistant for Bio-Based Materials.
      </Typography>
      <Link
        href={DOCUMENTATION_URL}
        target="_blank"
        rel="noopener"
        sx={styles.starterFAQLink}
        data-attr="learn-more-link"
      >
        Click here to learn more →
      </Link>
      <Typography
        sx={
          typeof styles.starterPromptsTitle === "function"
            ? styles.starterPromptsTitle(theme)
            : styles.starterPromptsTitle
        }
      >
        Try asking:
      </Typography>
      {displayPrompts.map((prompt, index) => (
        <Button
          key={index}
          variant="text"
          onClick={() => onPromptSend(prompt.message)}
          sx={
            typeof styles.starterPromptButton === "function"
              ? styles.starterPromptButton(theme)
              : styles.starterPromptButton
          }
          disableElevation
          disableRipple
          data-attr={`starter-prompt-${prompt.category}`}
        >
          {prompt.label}
        </Button>
      ))}
    </Box>
  );
};

export default StarterPage;
